import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Heading2, Heading3 } from '../../ui/Typography/Heading';
import { updateConfigOnboardingSettings } from '../../../redux/config/slice';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { OnboardingProgress } from '../OnboardingProgress/OnboardingProgress';
import { OnboardingActions } from '../OnboardingActions/OnboardingActions';
import { selectUpdateConfigLoading, selectConfigOnboardingImportSource } from '../../../redux/config/selectors';
import { ONBOARDING_STEPS, ONBOARDING_SOURCE_TYPES } from '../../../consts/consts';
import {
  OnboardingHeaderGroup,
  OnboardingContent,
  OnboardingContentGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingContentInfo,
  OnboardingContentGroupText,
  OnboardingDataSourceCardsGroup,
  OnboardingDataSourceCard,
  OnboardingDataSourceCardContent,
  OnboardingDataSourceCardBadge,
  OnboardingDataSourceCardDescription
} from '../../ui/Layout/OnboardingLayout';

export const OnboardingStepDataSourceComponent = ({
  updateConfigOnboardingSettings,
  updateConfigLoading,
  savedImportSource
}) => {
  const [selectedImportSource, setSelectedImportSource] = useState(savedImportSource || ONBOARDING_SOURCE_TYPES.IMPORT);
  const nextHint =
    selectedImportSource === ONBOARDING_SOURCE_TYPES.API
      ? 'Eigenständig über Schnittstelle informieren'
      : 'Stammdaten über oqio importieren';

  const handleBack = () => {
    updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.NOTIFICATIONS, dataSource: selectedImportSource });
  };

  const handleNext = () => {
    const nextStep =
      selectedImportSource === ONBOARDING_SOURCE_TYPES.API ? ONBOARDING_STEPS.API_INFO : ONBOARDING_STEPS.IMPORT_UPLOAD;
    updateConfigOnboardingSettings({ step: nextStep, dataSource: selectedImportSource });
  };

  const handleImportSourceChange = (e) => {
    setSelectedImportSource(e.target.value);
  };

  return (
    <>
      <OnboardingNavbar loading={updateConfigLoading} />
      <OnboardingProgress />
      <OnboardingContent className="step-interface">
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup>
            <OnboardingContentTitle>
              <Heading2>Stammdaten importieren</Heading2>
            </OnboardingContentTitle>
            <OnboardingContentInfo>
              <OnboardingContentGroupText>
                Damit Schäden gemeldet und bearbeitet werden können, müssen zunächst Ihre Stammdaten importiert werden.
              </OnboardingContentGroupText>
            </OnboardingContentInfo>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="step-interface content">
            <OnboardingDataSourceCardsGroup onChange={handleImportSourceChange} value={selectedImportSource}>
              <OnboardingDataSourceCard value={ONBOARDING_SOURCE_TYPES.IMPORT}>
                <OnboardingDataSourceCardContent>
                  <OnboardingDataSourceCardBadge>Empfehlung</OnboardingDataSourceCardBadge>
                  <Heading3>Import direkt in oqio</Heading3>
                  <OnboardingDataSourceCardDescription>
                    Über oqio kann der gesamte Schadenprozess abgebildet werden. Dafür werden im nächsten Schritt
                    Stammdaten importiert. Schäden können anschließend durch die Immobilienwirtschaft oder beauftragte
                    Reparaturdienstleister im Portal gemeldet und dokumentiert werden.
                  </OnboardingDataSourceCardDescription>
                </OnboardingDataSourceCardContent>
              </OnboardingDataSourceCard>

              <OnboardingDataSourceCard value={ONBOARDING_SOURCE_TYPES.API}>
                <OnboardingDataSourceCardContent>
                  <OnboardingDataSourceCardBadge $alternative>Alternative</OnboardingDataSourceCardBadge>
                  <Heading3>Import über eine Schnittstelle</Heading3>
                  <OnboardingDataSourceCardDescription>
                    oqio kann an ERP-Systeme der Immobilienwirtschaft angebunden werden. Die Aktivierung erfolgt
                    ausschließlich über den jeweiligen ERP-Anbieter und muss von der Immobilienwirtschaft eigenständig
                    beauftragt werden.
                  </OnboardingDataSourceCardDescription>
                </OnboardingDataSourceCardContent>
              </OnboardingDataSourceCard>
            </OnboardingDataSourceCardsGroup>
          </OnboardingContentGroup>
        </OnboardingStepWrapper>
        <OnboardingActions onBack={handleBack} onNext={handleNext} nextHint={nextHint} loading={updateConfigLoading} />
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateConfigLoading: selectUpdateConfigLoading(state),
  savedImportSource: selectConfigOnboardingImportSource(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings
};

export const OnboardingStepDataSource = connect(mapStateToProps, mapDispatchToProps)(OnboardingStepDataSourceComponent);
